module.exports = {
  type: 'hex-radio',
  group: 'radio',
  name: '单选框',
  isForm: true,
  props: {
    innerText: {
      name: '文字',
      default: '11',
      isMain: true,
      isFormShowName: true,
      isFormField: true,
      show: {
        prop: 'isChooseDataSource',
        value: '1'
      }
    },
    type: {
      name: '是否选择按钮',
      default: '',
      type: 'enum',
      values: [{
        value: 'button',
        text: '按钮类型'
      }, {
        value: '',
        text: '默认类型'
      }]
    },
    complexEvents: {
      name: '复杂方法',
      type: 'complex-events',
      default: [{
        type: 'change',
        bind: ''
      }],
      values: []
    },
  },
  style: {},
  // 新的events 用来处理编译用
  interfaces: {
  },

  // events 保证原来不报错
  events: {}
}



// WEBPACK FOOTER //
// ./packages/components/radio/src/define.js